// extracted by mini-css-extract-plugin
var _1 = "EntityPhaseListLoading-moduleEntityPhaseListLoading__sIj5t";
var _2 = "EntityPhaseListLoading-modulebackPart__bCyHC";
var _3 = "EntityPhaseListLoading-modulebody__dpmF9 Skeleton-moduleSkeleton__Mlrfv";
var _4 = "EntityPhaseListLoading-modulefrontPart__q4y5H";
var _5 = "EntityPhaseListLoading-moduleitem__GX95a";
export { _1 as "EntityPhaseListLoading", _2 as "backPart", _3 as "body", _4 as "frontPart", _5 as "item" }
